var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertMonarch5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 3C45.3594 3 57 14.6407 57 29C57 43.3594 45.3594 55 31 55C16.6406 55 5 43.3594 5 29C5 14.6407 16.6406 3 31 3Z",
    stroke: "#E3000F",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3176 15.2516L27.0938 26.6839L16.4778 26.1048L25.5547 32.9474L21.7642 43.666L30.5982 36.4627L38.8711 43.666L35.2542 32.3716L44.1575 26.1048L33.0881 26.3283L30.3176 15.2516Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3176 15.2516L27.0938 26.6839L16.4778 26.1048L25.5547 32.9474L21.7642 43.666L30.5982 36.4627L38.8711 43.666L35.2542 32.3716L44.1575 26.1048L33.0881 26.3283L30.3176 15.2516Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49919 47.9759C3.56079 48.0322 3.81668 48.1546 4.26721 48.3387C4.72081 48.5202 5.14185 48.728 5.53145 48.9574C5.92079 49.1895 6.26467 49.5065 6.56067 49.9121C6.85654 50.3172 7.00586 50.8079 7.00586 51.3866C6.96319 52.3068 6.71 53.0854 6.2432 53.7201C5.77414 54.3546 5.18986 54.8293 4.48612 55.1415C3.78199 55.4506 3.06987 55.6131 2.35254 55.6267L2.46216 55.0666C2.98189 55.0666 3.50988 54.9522 4.04614 54.7201C4.58214 54.4906 5.02735 54.1679 5.37655 53.7522C5.72615 53.336 5.90186 52.8692 5.90186 52.3466C5.90186 51.6934 5.75001 51.1707 5.44348 50.7787C5.13655 50.3868 4.66747 50.0346 4.02987 49.7227C3.34733 49.3706 2.91799 49.1279 2.74479 48.9922C2.57133 48.8562 2.47802 48.672 2.46216 48.44C2.50482 48.1706 2.52869 47.9732 2.52869 47.8507C2.72855 45.7414 2.84616 44.6695 2.87789 44.6347H6.65401V45.8506H3.33936C3.22189 46.5975 3.15801 47.0347 3.14734 47.1626C3.18747 47.5654 3.30452 47.8346 3.49919 47.9759Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7192 45.9384C12.8376 45.9384 13.7442 46.9498 13.7442 48.197C13.7442 49.4446 12.8376 50.4557 11.7192 50.4557C10.6008 50.4557 9.69409 49.4446 9.69409 48.197C9.69409 46.9498 10.6008 45.9384 11.7192 45.9384Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7192 45.9384C12.8376 45.9384 13.7442 46.9498 13.7442 48.197C13.7442 49.4446 12.8376 50.4557 11.7192 50.4557C10.6008 50.4557 9.69409 49.4446 9.69409 48.197C9.69409 46.9498 10.6008 45.9384 11.7192 45.9384Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7969 54.1943H7.66895C7.66895 52.0438 9.51718 50.2999 11.7969 50.2999C14.0768 50.2999 15.9249 52.0438 15.9249 54.1943H11.7969Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7969 54.1943H7.66895C7.66895 52.0438 9.51718 50.2999 11.7969 50.2999C14.0768 50.2999 15.9249 52.0438 15.9249 54.1943H11.7969Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-593 -908)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertMonarch5);
export default __webpack_public_path__ + "static/media/convert_monarch5.fdf6af2fcdbf41941b288d572d528cc0.svg";
export { ForwardRef as ReactComponent };